module.exports = __webpack_public_path__ + "static/img/4007.cef70e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4007.png
// module id = 714
// module chunks = 0 1 12